const matrixConfigurationOptionsReverseMap = new Map<string, string>([
  ["Substrate", "SUBSTRATE_1"],
  ["Substrate 2", "SUBSTRATE_2"],
  ["Product", "PRODUCT"],
  ["Properties", "PROPERTIES"],
  ["Building Actions", "BUILDING_ACTIONS"],
  ["Specimen Treatment", "SPECIMEN_TREATMENT"],
  ["Conditions", "CONDITIONS"],
  ["Repetition", "REPETITION"],
]);

export default matrixConfigurationOptionsReverseMap;
